module.exports = __webpack_public_path__ + "img/jihuazongshu.dcd05184.jpg";